import '@formatjs/intl-locale/polyfill';
import '@formatjs/intl-numberformat/locale-data/en';
import '@formatjs/intl-numberformat/polyfill';
import './index.css';
import 'typeface-inter';
import '@fontsource/inter-tight/400.css';
import '@fontsource/inter-tight/500.css';
import '@fontsource/inter-tight/600.css';
import '@fontsource/inter-tight/700.css';

import Axios from 'axios';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import App from './app/App';
import { initAxios } from './app/services/axios';
import store, { fromAccounts, fromAuth } from './app/store';
import {
  initializeFrontendObservability,
  reportFrontendStatus,
  updateFrontendObservabilityIdentity,
} from './frontendObservability';

const frontendObservability = initializeFrontendObservability();

if (frontendObservability) {
  const syncIdentity = () => {
    const state = store.getState();
    updateFrontendObservabilityIdentity(frontendObservability, {
      accountId: fromAccounts.selectSelectedAccount(state)?.id,
      userId: fromAuth.selectUser(state)?.id,
    });
  };

  syncIdentity();
  store.subscribe(syncIdentity);
}

const renderApplication = async () => {
  // Only explicit local acceptance builds may load this harness.
  if (process.env.REACT_APP_FARO_ENVIRONMENT === 'local'
    && process.env.REACT_APP_FARO_ACCEPTANCE === 'true'
    && new URLSearchParams(window.location.search).get('faro-acceptance') === 'true') {
    const { default: LocalFaroAcceptance } = await import('./LocalFaroAcceptance');
    ReactDOM.render(
      <LocalFaroAcceptance faro={frontendObservability} />,
      document.getElementById('root'),
      () => reportFrontendStatus('master.ready', {
        bundle: 'master-app-ui',
        component: 'bootstrap',
      }),
    );
    return;
  }

  Axios.defaults.baseURL = process.env.REACT_APP_API_URL ?? process.env.PUBLIC_URL;
  initAxios();
  ReactDOM.render(
    <StrictMode>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <CookiesProvider>
          <App />
        </CookiesProvider>
      </BrowserRouter>
    </StrictMode>,
    document.getElementById('root'),
    () => reportFrontendStatus('master.ready', {
      bundle: 'master-app-ui',
      component: 'bootstrap',
    }),
  );

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  // serviceWorker.unregister();
};

renderApplication().catch(error => {
  // A failed normal render or acceptance import must leave a browser diagnostic.
  // eslint-disable-next-line no-console
  console.error(error);
});
